import {
  GET_EXPERIMENT,
  ADD_EXPERIMENT,
  UPDATE_EXPERIMENT_INFO,
  UPDATE_SINGLE_EXPERIMENT,
  CLEAR_SWEEP_INFO,
  UPDATE_BASE_INTERFACES_INFO,
  UPDATE_SWEEP_CREATE_STATUS,
  UPDATE_EXPERIMENTS_STATUS,
  UPDATE_ADD_LOADING,
  UPDATE_LOADING_FORM_TYPE,
  UPDATE_STATE_INFO
} from './actionTypes';

export const getExperiment = (id) => ({
  type: GET_EXPERIMENT,
  id
})

export const addExperiment = (itemData) => ({
  type: ADD_EXPERIMENT,
  itemData
});

export const updateExperimentInfo = (info, currentType) => ({
  type: UPDATE_EXPERIMENT_INFO,
  info,
  currentType
});

export const updateSingleExperiment = ({ currentType, params }) => ({
  type: UPDATE_SINGLE_EXPERIMENT,
  currentType,
  params
});

export const updateExperimentStatus = ({ experimentIds, status }) => ({
  type: UPDATE_EXPERIMENTS_STATUS,
  experimentIds,
  status
})

export const updateSweepCreateStatus = (status) => ({
  type: UPDATE_SWEEP_CREATE_STATUS,
  status
});

export const clearSweepInfo = () => ({
  type: CLEAR_SWEEP_INFO
})

export const updateAddLoading = (loading) => ({
  type: UPDATE_ADD_LOADING,
  loading
})

export const updateStateInfo = (info, currentType) => ({
  type: UPDATE_STATE_INFO,
  info,
  currentType
})